/**
 Validates org numbers from Canada
 */
export const validateCanadaOrgNumber = (number: string) => {
  const canadaOrgNumberRegex = /^(BC)?\d{7}$/g;
  return canadaOrgNumberRegex.test(number);
};
